import axios from 'axios'
import cookies from 'js-cookie'

window.axios = axios

const base_url = import.meta.env.VITE_APP_BACKEND_URL ? `${import.meta.env.VITE_APP_BACKEND_URL}` : 'http://localhost:8000'

window.axios.defaults.baseURL = `${base_url}/api`
/* asli yg kadang bikin cors error krn rekues fron end pake allow origin pdhal bekend saja yg boleh
window.axios.defaults.headers.common = {
    'Access-Control-Allow-Origin': base_url,
    'X-Requested-With': 'XMLHTTPRequest',
    'Accept': 'application/json'
}
*/
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json'
}

/*asli ny ini yg bikin eror
var token = cookies.get('x-access-token');

if (token) {
    console.info('bootstrap default here', token)
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
*/
axios.interceptors.request.use((config) => {

    const token = cookies.get('x-access-token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        delete config.headers.Authorization;
    }

    return config;

});